import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { IHolidayDetail } from '../../interfaces/iholiday-detail';
import { VideoTypes } from '../../../../../shared/models/video-types.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GalleryModalComponent } from '../../../../../shared/components/gallery-modal/gallery-modal.component';
import { Subscription } from 'rxjs';
import { WidgetService } from '../../../../../shared/services/widget.service';
import { PostMessageService } from '../../../../../shared/services/post-message.service';

@Component({
  selector: 'app-detail-gallery',
  templateUrl: './detail-gallery.component.html',
  styleUrls: ['./detail-gallery.component.scss'],
})
export class DetailGalleryComponent implements OnInit, OnChanges, OnDestroy {
  @Input() holidayDetails: IHolidayDetail;

  videoTypes = VideoTypes;
  allImages: string[] = [];
  videoId: string = '';

  private isWidget: boolean;

  private isWidgetSubscription: Subscription;

  constructor(
    private _modalService: NgbModal,
    private _widgetService: WidgetService,
    private _postMessageService: PostMessageService
  ) {}

  ngOnInit(): void {
    this.isWidgetSubscription = this._widgetService
      .isWidget()
      .subscribe((isWidget) => {
        this.isWidget = isWidget;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.holidayDetails && this.holidayDetails) {
      this.allImages = this.holidayDetails.images || [];
      this.videoId =
        this.holidayDetails.videos?.find(
          (video) => video.type === this.videoTypes.YOUTUBE
        )?.code || null;
    }
  }

  openGallery(imgsrc: number): void {
    const modalRef = this._modalService.open(GalleryModalComponent, {
      size: 'xl',
      windowClass: this.isWidget ? 'modal-mid' : 'modal-full',
    });
    modalRef.componentInstance.elements = this.allImages;
    modalRef.componentInstance.selectedElement = imgsrc;
  }

  ngOnDestroy(): void {
    this.isWidgetSubscription?.unsubscribe();
  }
}
